import { Eyebrow } from "./Typo";
import { Btn } from "./Btn";
import { Script } from "./Script";

export const IconList = ({ items, testid }) => (
  <ul className="ilist" data-testid={testid}>
    {items.map(([Icon, text], i) => (
      <li key={text} style={{ "--c": `var(--${["cyan", "magenta", "amber", "violet"][i % 4]})` }}>
        <span><Icon size={17} aria-hidden="true" /></span>{text}
      </li>
    ))}
  </ul>
);

export const OfferPanel = ({ id, eyebrow, title, sub, bullets, cta, note, script, visual, testid, tone = "cyan" }) => (
  <section className="section panel-sec" aria-labelledby={id}>
    <article className={`opanel tone-${tone}`} data-reveal data-testid={testid}>
      <div className="opanel-text">
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 id={id}>{title}</h2>
        <p className="lead">{sub}</p>
        <IconList items={bullets} testid={`${testid}-bullets`} />
        <div className="actions"><Btn to={cta.to} testid={cta.testid}>{cta.label}</Btn></div>
        {note && <p className="opanel-note" data-testid={`${testid}-note`}>{note}</p>}
      </div>
      <div className="opanel-visual">{visual}</div>
      {script && <Script className="opanel-script">{script}</Script>}
    </article>
  </section>
);
